import React, { useState, useEffect } from "react";

const cardsData = [
  {
    id: 1,
    front: "Privileged Access Security",
    image: "https://www.silverfort.com/wp-content/uploads/2025/02/PAS-DB-1-1.svg",
    title: "Privileged Access Security (PAS)",
    back: "Go beyond managing privileged accounts",
    details: `Go beyond managing your privileged accounts. Secure them.
Don’t wait until it's too late. Discover, classify and enforce least privilege and Just-In-Time (JIT) access policies for all your privileged users within days.`,
  },
  {
    id: 2,
    front: "NHI Security",
    image: "https://www.silverfort.com/wp-content/uploads/2025/02/NHI-DB-1-1.svg",
    title: "Non-Human Identity (NHI) Security",
    back: "Discover and protect non-human identities",
    details:`Every non-human identity—in view and in control.
Discover and scale protection to all non-human identities in your identity infrastructure with a single click. Cloud and on-prem. Known and unknown.`,
  },
  {
    id: 3,
    front: "Universal MFA",
    image: "https://www.silverfort.com/wp-content/uploads/2025/02/MFA-DB-1-1.svg",
    title: "Universal MFA",
    back: "Extend multi-factor authentication to any system",
    details: `Push MFA beyond limits. Protect everything.
When we say universal, we mean it. Extend MFA protection to Active Directory managed resources without modifying them, including legacy applications, command line interfaces and OT systems.`,
  },
  {
    id: 4,
    front: "Authentication Firewall",
    image: "https://www.silverfort.com/wp-content/uploads/2025/02/Authentication-firewall-DB-1-1.svg",
    title: "Authentication Firewall",
    back: "Stop unauthorized access with Zero Trust policies",
    details: `Boost your environment’s resilience with the power of deny.
Protect your identity infrastructure from within. Govern and control users’ access based on their identity with no infrastructure changes with Silverfort’s authentication firewall.`,
  },
  {
    id: 5,
    front: "ITDR",
    image: "https://www.silverfort.com/wp-content/uploads/2025/02/IDTR-DB-2.svg",
    title: "Identity Threat Detection & Response",
    back: "Detect and respond to attacks in real time",
    details: `Detect and respond to identity threats. Anytime, anywhere.
Make every second count. Detect and block credential access, privilege escalation, and lateral movement attempts, whether on-prem, in the cloud—or both.`,
  },
  {
    id: 6,
    front: "ISPM",
    image: "https://www.silverfort.com/wp-content/uploads/2025/02/ISPM-DB-1-1.svg",
    title: "Identity Security Posture Management",
    back: "Uncover, map and analyze identity security exposures",
    details: `Find, fix and fortify every identity weakness, everywhere 
You can't protect yourself from the risks you can't see. Enhance your resilience with automated discovery and rapid mitigation of the weaknesses that expose your hybrid environment to identity threats.`,
  },
];

export default function Cards() {
  const [selectedCard, setSelectedCard] = useState(null);
  const [isHoverDevice, setIsHoverDevice] = useState(true);
  const [flippedCard, setFlippedCard] = useState(null);

  useEffect(() => {
    // detect hover capability
    const mq = window.matchMedia("(hover: hover)");
    setIsHoverDevice(mq.matches);

    const handler = (e) => setIsHoverDevice(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const handleCardClick = (card) => {
    if (isHoverDevice) {
      // Desktop: open modal immediately
      setSelectedCard(card);
    } else {
      // Mobile / tablet
      if (flippedCard === card.id) {
        // already flipped → open modal
        setSelectedCard(card);
      } else {
        // first tap → flip only
        setFlippedCard(card.id);
      }
    }
  };

  return (
    <>
      <div className="card-grid">
        {cardsData.map((card) => (
          <div
            key={card.id}
            className={`card ${flippedCard === card.id ? "flipped" : ""}`}
            onClick={() => handleCardClick(card)}
          >
            <div className="card-inner">
              {/* FRONT */}
              <div className="card-front">
                <img src={card.image} alt={card.front} className="card-img" />
                <span>{card.front}</span>
              </div>
              {/* BACK */}
              <div className="card-back">
                <h5>{card.title}</h5>
                <div className="separator" />
                <span>{card.back}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedCard && (
        <div className="modall-overlay" onClick={() => setSelectedCard(null)}>
          <div className="modall-content" onClick={(e) => e.stopPropagation()}>
            <h2>{selectedCard.title}</h2>
            <p style={{marginTop:"30px"}}>{selectedCard.details}</p>
            <button
              style={{ width: "100px", marginTop: "20px" }}
              className="custom-buttonS"
              onClick={() => setSelectedCard(null)}
            >
              <span>Close</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
}